if (!customElements.get("m-flasher")) {
  class MFlasher extends HTMLElement {
    connectedCallback() {
      this.locale = this.dataset.locale || "de";
      this.currency = this.dataset.currency || "EUR";
      this.i18n = {
        pickFirst: this.dataset.i18nPickfirst || "",
        added: this.dataset.i18nAdded || "",
        errAdd: this.dataset.i18nErradd || "",
      };
      this.unlockVariant = parseInt(this.dataset.unlockVariant || "0", 10) || 0;
      this.unlockCents = Math.round(parseFloat(this.dataset.unlockPrice || "0") * 100);
      this.ecuNewVariant = parseInt(this.dataset.ecunewVariant || "0", 10) || 0;
      this.ecuNewCents = Math.round(parseFloat(this.dataset.ecunewPrice || "0") * 100);

      this.pkgWrap = this.querySelector("[data-pkgs]");
      this.pkgs = Array.from(this.querySelectorAll("[data-pkg]"));
      this.versionStep = this.querySelector("[data-version-step]");
      this.versionLabel = this.querySelector("[data-version-label]");
      this.toggleWrap = this.querySelector("[data-version-toggle]");
      this.unlockBox = this.querySelector("[data-unlock-box]");
      this.unlockCheck = this.querySelector("[data-unlock-check]");
      this.ecuNewCheck = this.querySelector("[data-ecunew-check]");
      this.addons = Array.from(this.querySelectorAll("[data-addon]"));
      this.totalEl = this.querySelector("[data-total]");
      this.totalModelEl = this.querySelector("[data-total-model]");
      this.deliveryEl = this.querySelector("[data-delivery]");
      this.atc = this.querySelector("[data-atc]");
      this.errorEl = this.querySelector("[data-error]");
      this.modeBtns = Array.from(this.querySelectorAll("[data-mode]"));

      this.mode = "flasher";
      this.selectedPkg = null;
      this.currentVariant = 0; // cents-bearing chosen main variant id
      this.currentVariantPrice = 0;

      this._applying = false;

      this._bind();
      this._renderDelivery();
      this._applyUrl();
      this._recompute();
    }

    _money(cents) {
      try {
        return new Intl.NumberFormat(this.locale, {
          style: "currency",
          currency: this.currency,
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + " " + this.currency;
      }
    }

    _bind() {
      this.pkgs.forEach((pkg) => {
        const radio = pkg.querySelector(".m-flasher__pkg-radio");
        radio.addEventListener("change", () => this._selectPkg(pkg));
        // clicking the disclosure must not toggle the radio
        pkg.querySelectorAll("details, details *").forEach((el) => {
          el.addEventListener("click", (e) => e.stopPropagation());
        });
      });

      if (this.unlockCheck)
        this.unlockCheck.addEventListener("change", () => {
          this._recompute();
          this._syncUrl();
        });
      if (this.ecuNewCheck)
        this.ecuNewCheck.addEventListener("change", () => {
          this._recompute();
          this._syncUrl();
        });

      this._initAddons();

      this.modeBtns.forEach((b) => b.addEventListener("click", () => this._setMode(b.dataset.mode)));

      this.atc.addEventListener("click", () => this._addToCart());
    }

    _params() {
      try {
        return new URLSearchParams(window.location.search);
      } catch (e) {
        return new URLSearchParams();
      }
    }

    // Write the current selection into the URL so it can be shared as a deep link.
    _syncUrl() {
      if (this._applying) return;
      try {
        const params = this._params();
        ["group", "v", "mode", "add", "unlock", "ecu"].forEach((k) => params.delete(k));

        if (this.mode === "zusatz") params.set("mode", "zusatz");

        if (this.selectedPkg) {
          if (this.selectedPkg.dataset.key) params.set("group", this.selectedPkg.dataset.key);
          if (this.currentVariant) params.set("v", this.currentVariant);
        }

        if (this.mode === "flasher" && this.unlockBox && !this.unlockBox.hidden) {
          if (this.unlockCheck && !this.unlockCheck.checked) params.set("unlock", "0");
          if (this.ecuNewCheck && this.ecuNewCheck.checked) params.set("ecu", "1");
        }

        const adds = [];
        this.addons.forEach((row) => {
          const input = row.querySelector("[data-qty]");
          const q = input ? parseInt(input.value, 10) || 0 : 0;
          if (q > 0 && row._flVariant) adds.push(row._flVariant + ":" + q);
        });
        if (adds.length) params.set("add", adds.join(","));

        const qs = params.toString();
        const url = window.location.pathname + (qs ? "?" + qs : "") + window.location.hash;
        history.replaceState(null, "", url);
      } catch (e) {}
    }

    // Restore a selection from the URL on load (deep link / shared link / landing page).
    _applyUrl() {
      this._applying = true;
      const params = this._params();

      // 1) main package + version
      const v = parseInt(params.get("v") || "0", 10) || 0;
      const g = params.get("group");
      let pkg = null;
      let targetVid = 0;
      if (v) {
        pkg = this.pkgs.find(
          (p) => parseInt(p.dataset.vaId || "0", 10) === v || parseInt(p.dataset.vbId || "0", 10) === v
        );
        if (pkg) targetVid = v;
      }
      if (!pkg && g) pkg = this.pkgs.find((p) => p.dataset.key === g);
      if (!pkg && this.dataset.defaultKey) pkg = this.pkgs.find((p) => p.dataset.key === this.dataset.defaultKey);

      if (pkg) {
        const radio = pkg.querySelector(".m-flasher__pkg-radio");
        if (radio) radio.checked = true;
        this._selectPkg(pkg);
        if (targetVid) {
          const btn = this.toggleWrap.querySelector('.m-flasher__toggle-btn[data-vid="' + targetVid + '"]');
          if (btn && !btn.disabled) this._selectVariant(btn, true);
        }
      }

      // 2) unlock / ecu (applied after package, which resets the unlock default)
      if (this.unlockBox && !this.unlockBox.hidden) {
        if (params.get("unlock") === "0" && this.unlockCheck) this.unlockCheck.checked = false;
        if (params.get("ecu") === "1" && this.ecuNewCheck) this.ecuNewCheck.checked = true;
      }

      // 3) extra licences
      const add = params.get("add");
      if (add) {
        add.split(",").forEach((tok) => {
          const parts = tok.split(":");
          const vid = parseInt(parts[0], 10) || 0;
          let qty = parseInt(parts[1], 10) || 0;
          if (!vid || qty <= 0) return;
          if (qty > 20) qty = 20;
          const row = this.addons.find(
            (r) => parseInt(r.dataset.vaId || "0", 10) === vid || parseInt(r.dataset.vbId || "0", 10) === vid
          );
          if (!row) return;
          const isB = parseInt(row.dataset.vbId || "0", 10) === vid;
          row._flVariant = vid;
          row._flPrice = isB ? parseInt(row.dataset.vbPrice, 10) : parseInt(row.dataset.vaPrice, 10);
          const toggle = row.querySelector("[data-addon-toggle]");
          if (toggle) {
            const btns = toggle.querySelectorAll("button");
            btns.forEach((b, i) => b.classList.toggle("is-on", isB ? i === 1 : i === 0));
          }
          const priceEl = row.querySelector("[data-addon-price]");
          if (priceEl) priceEl.textContent = this._money(row._flPrice);
          const input = row.querySelector("[data-qty]");
          if (input) input.value = qty;
          row.classList.toggle("is-active", true);
        });
      }

      // 4) mode last (also opens the add-ons panel)
      if (params.get("mode") === "zusatz") this._setMode("zusatz");

      this._applying = false;
      this._recompute();
    }

    _setMode(mode) {
      this.mode = mode;
      this.classList.toggle("is-mode-zusatz", mode === "zusatz");
      this.modeBtns.forEach((b) => b.classList.toggle("is-on", b.dataset.mode === mode));
      const addons = this.querySelector("[data-addons]");
      if (addons) addons.open = mode === "zusatz";
      this._recompute();
      this._syncUrl();
    }

    _selectPkg(pkg) {
      this.selectedPkg = pkg;
      this.pkgs.forEach((p) => p.classList.toggle("is-selected", p === pkg));

      if (this.totalModelEl) {
        const nameEl = pkg.querySelector(".m-flasher__pkg-name");
        const name = nameEl ? nameEl.textContent.replace(/\s+/g, " ").trim() : "";
        const prefix = this.totalModelEl.dataset.label || "";
        this.totalModelEl.textContent = name ? prefix + " " + name : "";
      }

      // build A/B toggle
      const choiceLabel = pkg.dataset.choiceLabel || "Version";
      this.versionLabel.textContent = choiceLabel;
      this.toggleWrap.innerHTML = "";

      const opts = [];
      if (pkg.dataset.vaId) {
        opts.push({
          id: pkg.dataset.vaId,
          price: parseInt(pkg.dataset.vaPrice, 10),
          label: pkg.dataset.vaLabel || "A",
          available: pkg.dataset.vaAvailable !== "false",
        });
      }
      if (pkg.dataset.vbId) {
        opts.push({
          id: pkg.dataset.vbId,
          price: parseInt(pkg.dataset.vbPrice, 10),
          label: pkg.dataset.vbLabel || "B",
          available: pkg.dataset.vbAvailable !== "false",
        });
      }

      opts.forEach((o, idx) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "m-flasher__toggle-btn";
        btn.dataset.vid = o.id;
        btn.dataset.price = o.price;
        btn.disabled = !o.available;
        btn.innerHTML = "<b>" + o.label + "</b><small>" + this._money(o.price) + "</small>";
        btn.addEventListener("click", () => this._selectVariant(btn));
        this.toggleWrap.appendChild(btn);
      });

      // hide toggle if only one option
      this.versionStep.hidden = opts.length < 2;

      // default: first available option
      const firstBtn =
        this.toggleWrap.querySelector(".m-flasher__toggle-btn:not(:disabled)") ||
        this.toggleWrap.querySelector(".m-flasher__toggle-btn");
      if (firstBtn) this._selectVariant(firstBtn, true);

      // unlock box
      const needsUnlock = pkg.dataset.needsUnlock === "true" && this.unlockVariant > 0;
      if (this.unlockBox) {
        this.unlockBox.hidden = !needsUnlock;
        if (this.unlockCheck) this.unlockCheck.checked = needsUnlock; // default on when required
      }

      this._recompute();
      this._syncUrl();
    }

    _selectVariant(btn, silent) {
      this.toggleWrap.querySelectorAll(".m-flasher__toggle-btn").forEach((b) => b.classList.toggle("is-on", b === btn));
      this.currentVariant = parseInt(btn.dataset.vid, 10);
      this.currentVariantPrice = parseInt(btn.dataset.price, 10);
      if (!silent) {
        this._recompute();
        this._syncUrl();
      }
    }

    _initAddons() {
      this.addons.forEach((row) => {
        const toggleWrap = row.querySelector("[data-addon-toggle]");
        const priceEl = row.querySelector("[data-addon-price]");
        const opts = [];
        if (row.dataset.vaId) opts.push({ id: parseInt(row.dataset.vaId, 10), price: parseInt(row.dataset.vaPrice, 10), label: row.dataset.vaLabel || "A" });
        if (row.dataset.vbId) opts.push({ id: parseInt(row.dataset.vbId, 10), price: parseInt(row.dataset.vbPrice, 10), label: row.dataset.vbLabel || "B" });
        if (!opts.length) return;
        row._flVariant = opts[0].id;
        row._flPrice = opts[0].price;

        if (toggleWrap && opts.length >= 2) {
          opts.forEach((o, i) => {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "m-flasher__addon-choice-btn" + (i === 0 ? " is-on" : "");
            btn.textContent = o.label;
            btn.addEventListener("click", () => {
              row._flVariant = o.id;
              row._flPrice = o.price;
              if (priceEl) priceEl.textContent = this._money(o.price);
              toggleWrap.querySelectorAll("button").forEach((b) => b.classList.toggle("is-on", b === btn));
              this._recompute();
              this._syncUrl();
            });
            toggleWrap.appendChild(btn);
          });
        }

        const input = row.querySelector("[data-qty]");
        row.querySelectorAll("[data-step]").forEach((btn) => {
          btn.addEventListener("click", () => {
            let q = parseInt(input.value, 10) || 0;
            q += parseInt(btn.dataset.step, 10);
            if (q < 0) q = 0;
            if (q > 20) q = 20;
            input.value = q;
            row.classList.toggle("is-active", q > 0);
            this._recompute();
            this._syncUrl();
          });
        });
      });
    }

    _addonItems() {
      const items = [];
      this.addons.forEach((row) => {
        const q = parseInt(row.querySelector("[data-qty]").value, 10) || 0;
        if (q > 0 && row._flVariant) items.push({ id: row._flVariant, quantity: q, price: row._flPrice });
      });
      return items;
    }

    _unlockActive() {
      return this.mode === "flasher" && this.unlockBox && !this.unlockBox.hidden && this.unlockCheck && this.unlockCheck.checked && this.unlockVariant > 0;
    }

    _ecuNewActive() {
      return this.mode === "flasher" && this.unlockBox && !this.unlockBox.hidden && this.ecuNewCheck && this.ecuNewCheck.checked && this.ecuNewVariant > 0;
    }

    _hasMain() {
      return this.mode === "flasher" && !!(this.selectedPkg && this.currentVariant);
    }

    _recompute() {
      let total = 0;
      if (this._hasMain()) total += this.currentVariantPrice;
      this._addonItems().forEach((it) => (total += it.price * it.quantity));
      if (this._unlockActive()) total += this.unlockCents;
      if (this._ecuNewActive()) total += this.ecuNewCents;

      const hasMain = this._hasMain();
      const hasAddon = this._addonItems().length > 0;

      this.totalEl.textContent = hasMain || hasAddon ? this._money(total) : "-";
      this.atc.disabled = !(hasMain || hasAddon);
      if (this.errorEl) this.errorEl.textContent = "";
    }

    _renderDelivery() {
      if (!this.deliveryEl) return;
      const min = parseInt(this.dataset.deliveryMin, 10) || 5;
      const max = parseInt(this.dataset.deliveryMax, 10) || 9;
      const skip = this.dataset.skipWeekends === "true";
      const add = (days) => {
        const d = new Date();
        let added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          if (skip && (d.getDay() === 0 || d.getDay() === 6)) continue;
          added++;
        }
        return d;
      };
      const fmt = new Intl.DateTimeFormat(this.locale, { day: "numeric", month: "short" });
      const d1 = add(min);
      const d2 = add(max);
      this.deliveryEl.textContent = fmt.format(d1) + " - " + fmt.format(d2);
    }

    _lineItems() {
      const items = [];
      if (this._hasMain()) items.push({ id: this.currentVariant, quantity: 1 });
      this._addonItems().forEach((it) => items.push({ id: it.id, quantity: it.quantity }));
      if (this._unlockActive()) items.push({ id: this.unlockVariant, quantity: 1 });
      if (this._ecuNewActive()) items.push({ id: this.ecuNewVariant, quantity: 1 });
      return items;
    }

    _addToCart() {
      const items = this._lineItems();
      if (this.errorEl) this.errorEl.textContent = "";
      if (!items.length) {
        if (this.errorEl) this.errorEl.textContent = this.i18n.pickFirst;
        return;
      }

      const { MinimogSettings, MinimogStrings, MinimogEvents, MinimogTheme } = window;
      const cartDrawer = document.querySelector("m-cart-drawer");
      const sectionsToRender = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToRender } })
      );

      const config =
        typeof fetchConfig === "function"
          ? fetchConfig("javascript")
          : { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" } };
      config.method = "POST";
      config.body = JSON.stringify({ items, sections: sectionsToRender, sections_url: window.location.pathname });

      this._loading(true);

      const url = (MinimogSettings && MinimogSettings.routes && MinimogSettings.routes.cart_add_url) || "/cart/add.js";
      fetch(url, config)
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            if (this.errorEl) this.errorEl.textContent = response.description || this.i18n.errAdd;
            return;
          }
          if (MinimogSettings && MinimogSettings.use_ajax_atc) {
            if (cartDrawer && MinimogSettings.enable_cart_drawer) {
              if (MinimogTheme && MinimogTheme.Notification) {
                MinimogTheme.Notification.show({
                  target: cartDrawer.querySelector("m-cart-items"),
                  method: "prepend",
                  type: "success",
                  message: (MinimogStrings && MinimogStrings.itemAdded) || this.i18n.added,
                  delay: 400,
                });
              }
              cartDrawer.open();
            }
            if (MinimogEvents && MinimogTheme) {
              MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
            }
            document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: response } }));
          } else {
            window.location = (MinimogSettings && MinimogSettings.routes && MinimogSettings.routes.cart) || "/cart";
          }
        })
        .catch((err) => {
          console.error(err);
          if (this.errorEl) this.errorEl.textContent = this.i18n.errAdd;
        })
        .finally(() => this._loading(false));
    }

    _loading(on) {
      if (!this.atc) return;
      this.atc.classList[on ? "add" : "remove"]("m-spinner-loading");
      this.atc.disabled = on;
    }
  }
  customElements.define("m-flasher", MFlasher);
}
